// extracted by mini-css-extract-plugin
export default {"equipmentBlock":"Equipment_equipmentBlock__QE9Q8","title":"Equipment_title__hoSVz","chooseBlock":"Equipment_chooseBlock__oky2I","button":"Equipment_button__3S5K2"};